import React from 'react';

class GuestBookingForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      isOfferAccepted: false,
      errors: {}
    };
  }

  handleInputChange = (field, value) => {
    this.setState({ 
      [field]: value,
      errors: { ...this.state.errors, [field]: '' } // Очищаем ошибку при изменении
    });
  }

  validateForm = () => {
    const errors = {};
    const { firstName, lastName, email, phone, isOfferAccepted } = this.state;

    if (!firstName.trim()) {
      errors.firstName = 'Имя обязательно для заполнения';
    }

    if (!lastName.trim()) {
      errors.lastName = 'Фамилия обязательна для заполнения';
    }

    if (!email.trim()) {
      errors.email = 'Email обязателен для заполнения';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = 'Введите корректный email';
    }

    if (!phone.trim()) {
      errors.phone = 'Телефон обязателен для заполнения';
    } else if (!/^[\+]?[0-9\s\-\(\)]{10,}$/.test(phone)) {
      errors.phone = 'Введите корректный номер телефона';
    }

    if (!isOfferAccepted) {
      errors.offer = 'Необходимо принять условия оферты';
    }

    return errors;
  }

  handleSubmit = () => {
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const guestData = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      phone: this.state.phone,
      isOfferAccepted: this.state.isOfferAccepted
    };

    this.props.onSubmit(guestData);
  }

  renderModalContent() {
    const { firstName, lastName, email, phone, isOfferAccepted, errors } = this.state;

    return (
      <div className="modal" style={{ display: 'block' }}>
        <div className="modal-content guest-booking-form">
          <span className="close" onClick={this.props.onClose}>&times;</span>
          <div className="modal-body">
            <h3>Данные для бронирования</h3>
            <p className="form-description">Заполните контактные данные для подтверждения бронирования</p>
            
            <div className="form-group">
              <label>Имя *</label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => this.handleInputChange('firstName', e.target.value)}
                placeholder="Введите имя"
                className={errors.firstName ? 'error' : ''}
              />
              {errors.firstName && <div className="error-message">{errors.firstName}</div>}
            </div>

            <div className="form-group">
              <label>Фамилия *</label>
              <input
                type="text"
                value={lastName}
                onChange={(e) => this.handleInputChange('lastName', e.target.value)}
                placeholder="Введите фамилию"
                className={errors.lastName ? 'error' : ''}
              />
              {errors.lastName && <div className="error-message">{errors.lastName}</div>}
            </div>

            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                value={email}
                onChange={(e) => this.handleInputChange('email', e.target.value)}
                placeholder="example@mail.com"
                className={errors.email ? 'error' : ''}
              />
              {errors.email && <div className="error-message">{errors.email}</div>}
            </div>

            <div className="form-group">
              <label>Телефон *</label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => this.handleInputChange('phone', e.target.value)}
                placeholder="+7 (999) 123-45-67"
                className={errors.phone ? 'error' : ''}
              />
              {errors.phone && <div className="error-message">{errors.phone}</div>}
            </div>

            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={isOfferAccepted}
                  onChange={(e) => this.handleInputChange('isOfferAccepted', e.target.checked)}
                />
                <span className="checkmark"></span>
                Я ознакомился и согласен с <a href="/offer/" target="_blank">условиями публичной оферты</a> *
              </label>
              {errors.offer && <div className="error-message">{errors.offer}</div>}
            </div>
          </div>
          
          <div className="modal-footer">
            <button 
              id="confirmButton" 
              onClick={this.handleSubmit}
              className="btn btn-primary"
            >
              Продолжить к оплате
            </button>
            <button 
              onClick={this.props.onClose}
              className="btn btn-secondary"
            >
              Отмена
            </button>
          </div>
        </div>
        
        <style>
          {`
            .modal {
              display: none;
              position: fixed;
              z-index: 9999;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              overflow: auto;
              background-color: rgba(0,0,0,0.6);
            }

            .modal-content.guest-booking-form {
              background-color: #fefefe;
              margin: 5% auto;
              padding: 0;
              border: none;
              border-radius: 12px;
              width: 90%;
              max-width: 500px;
              box-shadow: 0 8px 32px rgba(0,0,0,0.2);
              position: relative;
            }

            .modal-body {
              padding: 30px;
            }

            .modal-body h3 {
              margin: 0 0 10px 0;
              color: #2c3e50;
              font-size: 24px;
              font-weight: 600;
              text-align: center;
            }

            .form-description {
              text-align: center;
              color: #666;
              margin-bottom: 25px;
              font-size: 14px;
            }

            .form-group {
              margin-bottom: 20px;
            }

            .form-group label {
              display: block;
              margin-bottom: 6px;
              color: #2c3e50;
              font-weight: 500;
              font-size: 14px;
            }

            .form-group input[type="text"],
            .form-group input[type="email"],
            .form-group input[type="tel"] {
              width: 100%;
              padding: 12px 16px;
              border: 2px solid #e0e0e0;
              border-radius: 8px;
              font-size: 16px;
              transition: border-color 0.2s ease;
              box-sizing: border-box;
            }

            .form-group input[type="text"]:focus,
            .form-group input[type="email"]:focus,
            .form-group input[type="tel"]:focus {
              outline: none;
              border-color: #6f42c1;
              box-shadow: 0 0 0 3px rgba(111, 66, 193, 0.1);
            }

            .form-group input.error {
              border-color: #e74c3c;
            }

            .error-message {
              color: #e74c3c;
              font-size: 12px;
              margin-top: 4px;
            }

            .checkbox-group {
              margin-top: 25px;
            }

            .checkbox-label {
              display: flex;
              align-items: flex-start;
              cursor: pointer;
              font-size: 14px;
              line-height: 1.4;
              color: #2c3e50;
            }

            .checkbox-label input[type="checkbox"] {
              position: absolute;
              opacity: 0;
              cursor: pointer;
            }

            .checkmark {
              width: 20px;
              height: 20px;
              background-color: #fff;
              border: 2px solid #e0e0e0;
              border-radius: 4px;
              margin-right: 12px;
              margin-top: 1px;
              flex-shrink: 0;
              transition: all 0.2s ease;
              position: relative;
            }

            .checkbox-label input[type="checkbox"]:checked + .checkmark {
              background-color: #6f42c1;
              border-color: #6f42c1;
            }

            .checkbox-label input[type="checkbox"]:checked + .checkmark::after {
              content: '';
              position: absolute;
              left: 6px;
              top: 2px;
              width: 6px;
              height: 10px;
              border: solid white;
              border-width: 0 2px 2px 0;
              transform: rotate(45deg);
            }

            .checkbox-label a {
              color: #6f42c1;
              text-decoration: none;
            }

            .checkbox-label a:hover {
              text-decoration: underline;
            }

            .modal-footer {
              padding: 20px 30px;
              border-top: 1px solid #f0f0f0;
              display: flex;
              gap: 12px;
              justify-content: flex-end;
              background-color: #fafafa;
              border-radius: 0 0 12px 12px;
            }

            .btn {
              padding: 12px 24px;
              border: none;
              border-radius: 8px;
              font-size: 14px;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.2s ease;
              text-decoration: none;
              display: inline-block;
              text-align: center;
            }

            .btn-primary {
              background: #6f42c1;
              color: white;
            }

            .btn-primary:hover {
              background: #5e35b1;
              transform: translateY(-1px);
            }

            .btn-secondary {
              background: #f8f9fa;
              color: #6c757d;
              border: 1px solid #dee2e6;
            }

            .btn-secondary:hover {
              background: #e9ecef;
            }

            .close {
              position: absolute;
              top: 15px;
              right: 20px;
              color: #aaa;
              font-size: 28px;
              font-weight: bold;
              cursor: pointer;
              z-index: 1;
            }

            .close:hover,
            .close:focus {
              color: #000;
            }

            /* Адаптивность */
            @media (max-width: 768px) {
              .modal-content.guest-booking-form {
                margin: 2% auto;
                width: 95%;
                max-height: 95vh;
                overflow-y: auto;
              }

              .modal-body {
                padding: 20px;
              }

              .modal-footer {
                padding: 15px 20px;
                flex-direction: column;
              }

              .btn {
                width: 100%;
              }
            }
          `}
        </style>
      </div>
    );
  }

  render() {
    if (!this.props.show) return null;
    return this.renderModalContent();
  }
}

export default GuestBookingForm; 